









































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { SortOrder } from '@/store/types/general.types';
import { Event } from '@/store/modules/admin/types/admin.types';

// components
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import EventCard from './EventCard.vue';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    EventCard
  }
})
export default class EventsList extends mixins(PaginationMixin) {
  sortHeaders = [
    { placeholder: 'Name', sortColumn: 'legalName', sort: true },
    { placeholder: 'Region', sort: false },
    { placeholder: 'Country', sort: false },
    { placeholder: 'Unique Members', sort: false }
  ];

  @Prop() public items!: Event[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: SortOrder;
}
